import { createApiQueryHook, IApiQueryFunction, mapRelationalValue, RelationalValue } from "../../utils";
import { IMediaResource } from "../types";

export type IMediaQueryParameters = {
    media?: RelationalValue<IMediaResource>;
};

export type IMediaQueryResult = IMediaResource;

export const mediaQuery: IApiQueryFunction<IMediaQueryParameters> = ({ media }) => {
    if (!media) {
        return;
    }

    return {
        method: "GET",
        url: `/media/${mapRelationalValue(media)}`,
    };
};

export const useMediaQuery = createApiQueryHook<IMediaQueryParameters, IMediaQueryResult>(mediaQuery);
